var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorIconOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 13.5,
    fill: "url(#paint0_linear_1588_2273)",
    fillOpacity: 0.08,
    stroke: "url(#paint1_linear_1588_2273)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1588_2273",
    x1: 0,
    y1: 20,
    x2: 40,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5a31ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f69ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1588_2273",
    x1: 0,
    y1: 20,
    x2: 40,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5a31ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f69ec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorIconOutline);
export default __webpack_public_path__ + "static/media/vector-icon-outline.010f2e3b4c94d4ba9ca877470b0f77aa.svg";
export { ForwardRef as ReactComponent };